import type { Card } from '../../../shared/types.ts';
import { CARD } from '../../../shared/cards.ts';

const SHADOW = 'rgba(0, 0, 0, 0.07)';
const BORDER = 'rgba(0, 0, 0, 0.12)';

/** The card's body: white panel with its colour strip. The face (text etc.) is drawn via the text cache. */
export function drawCard(ctx: CanvasRenderingContext2D, o: Card, lod: boolean, scale: number): void {
  const strip = Math.min(CARD.strip, o.h);
  if (lod) {
    // Level of detail: a plain rectangle with its strip.
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, o.w, o.h);
    ctx.fillStyle = o.color;
    ctx.fillRect(0, 0, o.w, strip);
    return;
  }
  const r = Math.min(CARD.radius, o.w / 2, o.h / 2);
  // A flat offset shape instead of shadowBlur, which is far too slow at scale.
  ctx.fillStyle = SHADOW;
  ctx.beginPath();
  ctx.roundRect(0, 2, o.w, o.h, r);
  ctx.fill();
  ctx.beginPath();
  ctx.roundRect(0, 0, o.w, o.h, r);
  ctx.fillStyle = '#FFFFFF';
  ctx.fill();
  ctx.strokeStyle = BORDER;
  ctx.lineWidth = 1 / scale;
  ctx.stroke();
  ctx.save();
  ctx.clip();
  ctx.fillStyle = o.color;
  ctx.fillRect(0, 0, o.w, strip);
  ctx.restore();
}
